'use strict';
import React, { Component } from 'react';

class PantallaPrincipalConcierge extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Concierge__logo">
            </div>
        );
    }
}

export default PantallaPrincipalConcierge;